jQuery(document).ready(function($) {
	if ($('.sf-field-post-meta-shows_applications .sf-level-0').hasClass('sf-option-active')) {
		$( ".casting-title" ).css({ 'display': "block" });
	}
});